<template>
  <div class="maps">
    <div
      ref="maps"
      class="map"
    />
  </div>
</template>

<script>
  import gmapsInit from './gmaps';
  export default {
    name: 'GoogleMaps',
    props: {
      googleMapsUrl: { type: String, required: true },
      locations: { type: Array, required: false, default: null },
      activeMarkerId: { type: String, required: false, default: null },
      defaultZoom: { type: Number, required: true },
      defaultLat: { type: String, required: true },
      defaultLong: { type: String, required: true },
    },
    data() {
      return {
        markers: [],
        map: null
      };
    },
    watch: {
      locations() {
        this.removeMarkers();
        this.addMarkers();
      },
      activeMarkerId() {
        this.setActiveMarker();
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        try {
          gmapsInit(this.googleMapsUrl).then(() => {
            this.map = new google.maps.Map(this.$refs.maps, this.mapsOptions({ lat: Number(this.defaultLat), long: Number(this.defaultLong), zoom: this.defaultZoom, minZoom: this.defaultZoom })); // eslint-disable-line no-undef
          });
        } catch (error) {
          console.error(error); // eslint-disable-line no-console
        }
      },
      mapsOptions({ lat = 39.799999, long = -89.650002, zoom = 3.5, minZoom = 3.5 }) {
        return { center: this.latLong(lat, long), zoom: zoom, minZoom: minZoom };
      },
      addMarkers() {
        if (this.locations.length <= 0) {
          return;
        }

        this.markers = this.locations.map((location, index) => {
          const infoWindow = this.infoWindow(location);

          const marker = new google.maps.Marker( // eslint-disable-line no-undef
            this.newMarker({
              markerId: location.store_id,
              position: this.latLong(location.latitude, location.longitude),
              icon: this.getIcon(index),
              infoWindow: infoWindow
            })
          );

          this.zoomEffect({ position: marker.getPosition() });
          this.addMarkerWindow(marker, location, infoWindow);

          return marker;
        });
      },
      removeMarkers() {
        this.markers.forEach(marker => {
          marker.setMap(null);
        });
      },
      setActiveMarker() {
        this.updateMarker(this.markers.find(m => m.markerId === this.activeMarkerId));
      },
      newMarker({ markerId, position, icon, infoWindow }) {
        return {
          markerId: markerId,
          position: position,
          map: this.map,
          icon: icon,
          infoWindow: infoWindow
        };
      },
      updateMarker(marker) {
        if (!marker) {
          return;
        }
        this.closeAllMarkers();
        this.map.panTo(marker.getPosition());
        marker.infoWindow.open(this.map, marker);
      },
      closeAllMarkers() {
        this.markers.forEach(marker => {
          marker.infoWindow.close(this.map, marker);
        });
      },
      addMarkerWindow(marker) {
        google.maps.event.addListener(marker, 'click', () => { // eslint-disable-line no-undef
          this.updateMarker(marker);
        });
        google.maps.event.addListener(this.map, 'click', () => { // eslint-disable-line no-undef
          this.closeAllMarkers();
        });
      },
      infoWindow(location) {
        return new google.maps.InfoWindow({ content: this.infoWindowContent(location) }); // eslint-disable-line no-undef
      },
      infoWindowContent(location) {
        return `<div class="info-window">
                  <p class="title" id="info-window-title"><span class="is-sr-only">Store name:</span> ${location.name}</p>
                  <p><span class="is-sr-only">Address:</span> ${location.address}</p>
                  <p>${location.city}, ${location.state}, ${location.zip}</p>
                  ${location.phone ? `<p><span class="is-sr-only">Phone number:</span> <a href="tel:${location.phone}">${location.phone}</a></p>` : ''}
                  <a href="https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(this.linkParams(location))}"
                    aria-describedby="info-window-title"
                    class="btn btn--ghost"
                    target="_blank">
                    <span>Get Directions</span>
                  </a>
                </div>`;
      },
      linkParams(location) {
        return `${location.address} ${location.city} ${location.state} ${location.state} ${location.zip}`;
      },
      getIcon(index, width = 40, height = 70) {
        return {
          url: `https://raw.githubusercontent.com/Concept211/Google-Maps-Markers/master/images/marker_blue${index + 1}.png`,
          scaledSize: new google.maps.Size(width, height) // eslint-disable-line no-undef
        };
      },
      latLong(lat, long) {
        return new google.maps.LatLng(lat, long); // eslint-disable-line no-undef
      },
      zoomEffect({ position, zoom = 14 }) {
        this.map.setCenter(position);
        this.map.setZoom(zoom);
      }
    }
  };
</script>

